import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_btn_add_table_head",
  "use": "lc_btn_add_table_head-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_btn_add_table_head\"><defs><style type=\"text/css\"></style></defs><path d=\"M64 128v768h896V128H64z m576 256v192H384V384h256z m0 256v192H384v-192h256zM128 384h192v192H128V384z m0 256h192v192H128v-192z m768 192h-192v-192h192v192z m0-256h-192V384h192v192z\" fill=\"#808080\" p-id=\"21263\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol